/*
 * Paws & Pearls — The Muse — Four Companion Balloons V1.1 PRELUDE
 * User-requested correction, 26 Oct 2026: companions depart BEFORE the Muse;
 * they are approximately 1.85x their V1 size. They never return.
 * IMPORTANT: Pauses and resumes ONLY V18's existing 39-second WAAPI motion.
 * Does not change the V18 source, flight keyframes, scroll tracking, landing,
 * 32 pearls, music source, House Sound system, or the four approved PNG designs.
 * Existing asset filename retained for safe replacement: NO second Liquid block.
 */
(function () {
  'use strict';
  var NS = 'ppMuseCompanionBalloonsV1';
  var stageId = 'pp-muse-balloon-stage';
  var configId = 'pp-muse-companion-assets';
  var MUSE_WAIT_MS = 4000;   // Four-second visual overture; 39s flight itself unchanged.
  var EXPECTED_FLIGHT_MS = 39000;  // Archived, user-approved V18.
  var ENLARGE = 1.85;        // Almost double the old companion image widths.
  var specs = [
    // Each companion begins BEFORE the Muse; asymmetry is intentional.
    { name: 'rose',  x: .16, y: .92, w: .145, max: 112, delay:    0, ms: 18700, drift: -.07,  sway: 5.3, depth: .92 },
    { name: 'black', x: .82, y: 1.01,w: .105, max: 92,  delay:  650, ms: 22700, drift: .055,  sway: 4.6, depth: .82 },
    { name: 'ivory', x: .34, y: 1.07,w: .118, max: 99,  delay: 1500, ms: 20500, drift: .075,  sway: 6.1, depth: .86 },
    { name: 'pearl', x: .91, y: .86, w: .086, max: 81,  delay: 2400, ms: 24200, drift: -.105, sway: 3.9, depth: .76 }
  ];
  var activeControllers = new WeakMap();

  function init() {
    var stage = document.getElementById(stageId);
    var config = document.getElementById(configId);
    if (!stage || !config || activeControllers.has(stage)) return;
    var button = stage.querySelector('.pp-balloon');
    if (!button) return;
    var urls = [config.dataset.rose, config.dataset.black, config.dataset.ivory, config.dataset.pearl];
    if (urls.some(function (value) {
      return !value || (value.indexOf('://') === -1 && value.charAt(0) !== '/');
    })) return;

    var media = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var running = false, sprites = [], frame = 0, generation = 0;
    var releaseTimer = 0, heldMotion = null, lastHeldMotion = null;

    // Warm browser cache; preserves original file URLs and avoids late sprite loads.
    if (typeof Image !== 'undefined') {
      urls.forEach(function (url) { var image = new Image(); image.src = url; });
    }

    function releaseMuse() {
      if (releaseTimer) { clearTimeout(releaseTimer); releaseTimer = 0; }
      var flight = heldMotion;
      heldMotion = null;
      if (flight && typeof flight.play === 'function') {
        try {
          // Only resume V18's existing animation. NEVER cancel/replace it.
          if (flight.playState === 'paused' || flight.playState === 'pending') flight.play();
        } catch (error) { console.warn('[P&P companion balloons] Could not resume Muse flight:', error); }
      }
    }

    function removeSprites() {
      generation++;
      running = false;
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      sprites.forEach(function (b) { b.node.remove(); });
      sprites = [];
    }

    function smooth(t) {
      var s = t * t * (3 - 2 * t);
      return .26 * t + .74 * s;
    }

    function tick(start, token, now) {
      if (generation !== token) return;
      var rect = stage.getBoundingClientRect();
      var elapsed = now - start, alive = false;
      for (var i = 0; i < sprites.length; i++) {
        var b = sprites[i], c = b.spec;
        if (elapsed < c.delay) { alive = true; continue; }
        var u = Math.min(1, (elapsed - c.delay) / c.ms);
        if (u >= 1) { b.node.remove(); continue; }
        alive = true;
        var progress = smooth(u);
        var rise = progress * b.rise;
        var drift = c.drift * rect.width * progress;
        var sway = Math.sin(u * 13.1 + i * 1.9) * c.sway * Math.sin(Math.PI * u);
        var centerX = rect.left + c.x * rect.width + drift + sway;
        // Larger balloons stay over the stage rather than cropping off its sides.
        centerX = Math.max(rect.left + b.size / 2,
                  Math.min(rect.right - b.size / 2, centerX));
        var y = rect.top + c.y * rect.height - rise - b.size;
        var scale = 1 - (1 - c.depth) * progress;
        var opacity = Math.min(1, (elapsed - c.delay) / 650);
        b.node.style.opacity = String(Math.max(0, opacity));
        b.node.style.transform = 'translate3d(' + (centerX - b.size / 2).toFixed(1) + 'px,' +
          y.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
      }
      if (alive) frame = requestAnimationFrame(function (next) { tick(start, token, next); });
      else { frame = 0; running = false; sprites = []; }
    }

    function locateV18Motion() {
      if (typeof button.getAnimations !== 'function') return null;
      try {
        var animations = button.getAnimations();
        for (var i = 0; i < animations.length; i++) {
          var a = animations[i];
          if (!a.effect || typeof a.effect.getTiming !== 'function') continue;
          var duration = Number(a.effect.getTiming().duration);
          if (Math.abs(duration - EXPECTED_FLIGHT_MS) < 1 &&
              a.playState !== 'finished' && a.playState !== 'idle') return a;
        }
      } catch (error) { console.warn('[P&P companion balloons] Motion lookup unavailable:', error); }
      return null;
    }

    function launch() {
      if (running || heldMotion || (media && media.matches)) return;
      // Original V18's handler must accept the click BEFORE this add-on acts.
      if (!button.classList.contains('pp-muse-flight-overlay')) return;
      var flight = locateV18Motion();
      if (flight && flight === lastHeldMotion) return; // never restart same V18 flight
      if (!flight) {
        // Preserve working V18 if a future theme/browser can't support the hold.
        console.warn('[P&P companion balloons] V18 motion not found; original flight proceeds unchanged.');
        return;
      }
      try { flight.pause(); }
      catch (error) {
        console.warn('[P&P companion balloons] Could not hold Muse; original flight proceeds:', error);
        return;
      }
      heldMotion = flight;
      lastHeldMotion = flight;
      releaseTimer = setTimeout(releaseMuse, MUSE_WAIT_MS);

      removeSprites();
      running = true;
      var rect = stage.getBoundingClientRect();
      var rise = Math.max(window.innerHeight + rect.height + 700,
                          Math.max(0, rect.bottom) + window.innerHeight + 700);
      for (var i = 0; i < specs.length; i++) {
        var c = specs[i];
        var img = document.createElement('img');
        img.src = urls[i];
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.decoding = 'async';
        img.draggable = false;
        var size = Math.min(c.max * ENLARGE, Math.max(30, rect.width * c.w * ENLARGE));
        // On very narrow viewports, contain the entire object inside the stage.
        size = Math.min(size, Math.max(30, rect.width * .40));
        img.style.cssText = 'position:fixed!important;left:0!important;top:0!important;' +
          'height:auto!important;max-width:none!important;object-fit:contain!important;' +
          'pointer-events:none!important;user-select:none!important;opacity:0;' +
          'z-index:2147482900!important;transform-origin:center center!important;' +
          'will-change:transform,opacity!important;width:' + size.toFixed(1) + 'px!important;';
        img.style.transform = 'translate3d(-200vw,-200vh,0)';
        document.body.appendChild(img);
        sprites.push({ node: img, spec: c, size: size, rise: rise });
      }
      var token = generation;
      var start = performance.now();
      frame = requestAnimationFrame(function (now) { tick(start, token, now); });
    }

    function onClick() { launch(); }
    function onSectionUnload(event) {
      if (event.target && event.target.contains(stage)) {
        // Original V18's own section handler will cancel the flight; be safe.
        releaseMuse();
        removeSprites();
        button.removeEventListener('click', onClick);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        activeControllers.delete(stage);
      }
    }
    button.addEventListener('click', onClick);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    activeControllers.set(stage, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
  window[NS] = { version: '1.1', companionsBeforeMuse: true, holdMs: MUSE_WAIT_MS, sizeMultiplier: ENLARGE };
})();
